// extracted by mini-css-extract-plugin
export default {"img":"cardGalleryDesktop_img__tVn72","cursor":"cardGalleryDesktop_cursor__-j2Wb"};